<template>
  <section class="login-screens" id="forgot-password-page">
    <section class="forgot-password-screen">
      <el-row>
        <el-col :md="12" :lg="14" :xs="24" :xl="14" class="login-screens-left hidden-sm-and-down">
          <div class="w-100">
            <div class="logo">
              <router-link to="/">
                <img src="/img/login-screens/Logo.png" alt="Nutron-logo" class="img-fluid" />
              </router-link>
            </div>
            <section class="copyright">
              <el-row>
                <el-col :lg="18" :md="24" :sm="24">
                  <p>Copyright © 2019</p>
                </el-col>
                <el-col :lg="6" :md="24" :sm="24">
                  <p>
                    Powered by
                    <a href="https://orotron.com/" target="_blank">OROTRON</a>
                  </p>
                </el-col>
              </el-row>
            </section>
          </div>
        </el-col>
        <!-- main content -->
        <slot />
        <!-- ./ main content -->
      </el-row>
    </section>
  </section>
</template>

<script>
export default {};
</script>
<style lang="scss">
  a {
    display: inline-block;
  }
  @media all and (max-width: 768px){
    .el-button {
      &+.el-button {
        margin-left: 0;
      }
    }
  }
</style>
